import type { Locale } from "./types.js";

/**
 * Nobody should face a blank box. Concrete, diaspora-specific prompts beat a
 * generic "tell us your story" (BBC UGC Hub + StoryCorps Great Questions).
 * Persian versions must read as warm spoken Persian, not translationese —
 * on the native-review list before launch.
 */
export const PROMPT_KEYS = [
  "left_for_good",
  "tradition",
  "phone_call",
  "packed",
  "children_persian",
  "memory_place",
] as const;
export type PromptKey = (typeof PROMPT_KEYS)[number];

export const PROMPTS: Record<PromptKey, Record<Locale, string>> = {
  left_for_good: {
    en: "The moment you knew you had left home for good.",
    fa: "لحظه‌ای که فهمیدی برای همیشه از خانه رفته‌ای.",
  },
  tradition: {
    en: "A tradition you kept alive far from where it began.",
    fa: "رسمی که دور از جایی که آغاز شد، زنده نگهش داشتی.",
  },
  phone_call: {
    en: "A phone call you still think about.",
    fa: "تماسی تلفنی که هنوز به آن فکر می‌کنی.",
  },
  packed: {
    en: "What you packed, and what you left behind.",
    fa: "چه چیزهایی را برداشتی و چه چیزهایی را جا گذاشتی.",
  },
  children_persian: {
    en: "The first time your children corrected your Persian, or you corrected theirs.",
    fa: "اولین باری که بچه‌هایت فارسی‌ات را تصحیح کردند، یا تو فارسی آن‌ها را.",
  },
  memory_place: {
    en: "A place you can only visit in memory.",
    fa: "جایی که فقط در خاطره می‌توانی به آن سر بزنی.",
  },
};
